import { AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileHelper, TextHelper } from 'src/app/helpers';
import { CourseModulePage } from 'src/app/models';
import { YoutubePlayerComponent } from 'src/app/shared/components/youtube-player/youtube-player.component';
import { CustomCourseElements, BIND_YOUTUBE_PLAYER_ELEMENT, BIND_VIDEO_JS_PLAYER_ELEMENT } from '../../shared/elements/custom-course-elements';
import { VideoJsPlayerComponent } from 'src/app/shared/components/video-js-player/video-js-player.component';
import { VideoPlayerViewModel } from 'src/app/shared/components/video-player/VideoPlayer.viewmodel';

@Component({
  selector: 'app-module-page-fhe',
  templateUrl: './module-page-fhe.component.html',
  styleUrls: ['./module-page-fhe.component.css', '../../shared/styles/custom-course-page.css']
})
export class ModulePageFheComponent extends CustomCourseElements implements OnInit, AfterViewInit {
  debug = false;
  // debug = true;

  @Input()
  set content(page: CourseModulePage) {
    this.page = page;
    this.pageContent = this.bindElements(page?.content);
    this.pageTimeToRead = TextHelper.estimateReading(this.pageContent);
    this.youtubeContent = this.loadYoutubeFrom(this.pageContent);
    this.videoJsContent = this.loadVideoJsFrom(this.pageContent);
  }

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  page!: CourseModulePage;
  pageContent!: string;
  pageTimeToRead = 0;

  youtubeContent?: string;
  youtubeParams = {
    src:      '',
    autoplay: '',
    width:    '',
    height:   '',
    style:    '',
  };

  videoJsContent?: string;
  videoJsParams = {
    src:      '',
    type:     '',
    poster:   '',
    captions: '',
    autoplay: '',
    width:    '',
    height:   '',
    style:    '',
  };

  pageContentBeforeVideo?: string;
  pageContentAfterVideo?: string;

  @ViewChild(YoutubePlayerComponent, { static: false })
  childYoutube?: YoutubePlayerComponent;

  @ViewChild(VideoJsPlayerComponent, { static: false })
  childVideoJs?: VideoJsPlayerComponent;

  initialized = false;

  get video(): VideoPlayerViewModel|null {
    return !this.initialized ? null : this.childYoutube || this.childVideoJs || null;
  }

  get pageDelay() {
    if (!this.delay) return 0;
    if (this.video) return this.video.duration / this.video.speed;
    return this.pageTimeToRead;
  }

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.initElements();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initialized = true;
    });
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  private loadYoutubeFrom(html: string) {
    if (!html) {
      return '';
    }

    const tag      = BIND_YOUTUBE_PLAYER_ELEMENT;
    const openTag  = '<'  + tag;
    const closeTag = '</' + tag + '>';

    if (!html.includes(openTag) || !html.includes(closeTag)) {
      return '';
    }

    const match = html.match(new RegExp(`${openTag}(.|\n)*?${closeTag}`));

    if (!match) {
      return '';
    }

    this.youtubeContent = match[0];

    const $video = $(this.youtubeContent);

    this.youtubeParams.src      = $video.attr('src')      || '';
    this.youtubeParams.autoplay = $video.attr('autoplay') || '';
    this.youtubeParams.width    = $video.attr('width')    || '';
    this.youtubeParams.height   = $video.attr('height')   || '';
    this.youtubeParams.style    = $video.attr('style')    || '';

    this.pageContentBeforeVideo = html.substring(0, html.indexOf(openTag))
    this.pageContentAfterVideo  = html.substring(html.indexOf(closeTag) + closeTag.length);

    return this.youtubeContent;
  }

  private loadVideoJsFrom(html: string) {
    if (!html) {
      return '';
    }

    const tag      = BIND_VIDEO_JS_PLAYER_ELEMENT;
    const openTag  = '<'  + tag;
    const closeTag = '</' + tag + '>';

    if (!html.includes(openTag) || !html.includes(closeTag)) {
      return '';
    }

    const match = html.match(new RegExp(`${openTag}(.|\n)*?${closeTag}`));

    if (!match) {
      return '';
    }

    this.videoJsContent = match[0];

    const $video = $(this.videoJsContent);

    this.videoJsParams.src      = $video.find('source').attr('src')  || '';
    this.videoJsParams.type     = $video.find('source').attr('type') || '';
    this.videoJsParams.poster   = $video.attr('poster')              || '';
    this.videoJsParams.captions = $video.find('track').attr('src')   || '';
    this.videoJsParams.autoplay = $video.attr('autoplay')            || '';
    this.videoJsParams.width    = $video.attr('width')               || '';
    this.videoJsParams.height   = $video.attr('height')              || '';
    this.videoJsParams.style    = $video.attr('style')               || '';

    this.pageContentBeforeVideo = html.substring(0, html.indexOf(openTag))
    this.pageContentAfterVideo  = html.substring(html.indexOf(closeTag) + closeTag.length);

    this.videoJsParams.src = FileHelper.switchToCdn(this.videoJsParams.src);
    this.videoJsParams.poster = FileHelper.switchToCdn(this.videoJsParams.poster);
    this.videoJsParams.captions = FileHelper.switchToCdn(this.videoJsParams.captions);

    if (!this.videoJsParams.poster) {
      this.videoJsParams.poster = FileHelper.changeFileExt(this.videoJsParams.src, 'png');
    }

    if (!this.videoJsParams.captions) {
      this.videoJsParams.captions = FileHelper.changeFileExt(this.videoJsParams.src, 'vtt');
    }

    return this.videoJsContent;
  }
}
